/**
 * CartSettingsPresenter
 * --
 */
import React from 'react';
import { Content, Title, Row, Col, InputFormTable } from 'components';
import { Input, Button, Radio } from 'antd';

const CartSettingsPresenter = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  const styles = {
    title: {
      fontSize: 24,
      fontWeight: 700,
      marginBottom: 20,
    },
    subTitle: {
      fontSize: 17,
      fontWeight: 500,
      lineHeight: '141%',
      marginBottom: 20,
    },
    button: {
      width: 80,
      height: 40,
      fontSize: 15,
      fontWeight: 600,
      margin: '0px 4px',
    },
    form: {
      input: {
        large: {
          width: 175,
          marginRight: 8,
        },
        medium: {
          width: 100,
          marginRight: 8,
        },
      },
      button: {
        marginRight: 8,
      },
      date: {
        width: 120,
      },
      text: {
        fontSize: 13,
        fontWeight: 400,
      },
    },
  };

  const form = [
    {
      label: '장바구니 저장 기간',
      form: [
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              오늘
            </Button>
          ),
        },
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              1주일
            </Button>
          ),
        },
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              1개월
            </Button>
          ),
        },
        {
          input: (
            <>
              <Input
                size="large"
                style={{ ...styles.form.input.large }}
                placeholder="직접입력"
              />
            </>
          ),
        },
      ],
    },
    {
      label: '세트상풍 노출여부',
      form: [
        {
          input: (
            <>
              <Radio.Group value={'노출함'}>
                <Radio value={'노출함'}>노출함</Radio>
                <Radio value={'노출안함'}>노출안함</Radio>
              </Radio.Group>
            </>
          ),
        },
      ],
    },
    {
      label: '장바구니 담기 확인창',
      form: [
        {
          input: (
            <>
              <Radio.Group value={'표시'}>
                <Radio value={'표시'}>표시</Radio>
                <Radio value={'표시안함'}>표시안함</Radio>
              </Radio.Group>
            </>
          ),
        },
      ],
    },
    {
      label: '구매 후 장바구니 삭제 확인창',
      form: [
        {
          input: (
            <>
              <Radio.Group value={'표시'}>
                <Radio value={'표시'}>표시</Radio>
                <Radio value={'표시안함'}>표시안함</Radio>
              </Radio.Group>
            </>
          ),
        },
      ],
    },
    {
      label: '위시리스트 담기 버튼 노출 여부',
      form: [
        {
          input: (
            <>
              <Radio.Group value={'노출함'}>
                <Radio value={'노출함'}>노출함</Radio>
                <Radio value={'노출안함'}>노출안함</Radio>
              </Radio.Group>
            </>
          ),
        },
      ],
    },
    {
      label: '계속 담아두기',
      form: [
        {
          input: (
            <>
              <Radio.Group value={'사용'}>
                <Radio value={'사용'}>사용</Radio>
                <Radio value={'사용안함'}>사용안함</Radio>
              </Radio.Group>
            </>
          ),
        },
      ],
    },
  ];

  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <Content maxWidth={'100%'} padding={20} backgroundColor={'none'}>
      <Row>
        <Col x={24}>
          <Title style={{ ...styles.title }}>장바구니 설정</Title>

          {/* 기본정보 */}
          <Content
            maxWidth={'100%'}
            padding={20}
            borderRadius={4}
            style={{ marginBottom: 40 }}
          >
            <Title style={{ ...styles.subTitle }}>기본 정보</Title>
            <InputFormTable form={form} />
          </Content>
          {/* 기본정보 끝 */}

          {/* 버튼 */}
          <Content maxWidth={'100%'} backgroundColor={'none'}>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Button
                size="large"
                type="primary"
                style={{
                  background: 'var(--primary-color)',
                }}
              >
                장바구니 설정
              </Button>
            </div>
          </Content>
          {/* 버튼 끝 */}
        </Col>
      </Row>
    </Content>
  );
};

export default CartSettingsPresenter;
